import { useCallback } from "react";
import { useDispatch } from "react-redux";

import FormGroup from "@/design/forms/FormGroup";
import { showSnackbar } from "@/store/reducers/app";
import Valkyrie, { viCopy } from "@sippy-platform/valkyrie";

import { Button, Tooltip } from "@mui/material";
import { createHighlighter } from "@tanstack/highlight/core";
import { json } from "@tanstack/highlight/languages/json";
import { type HighlightedCodeBlockProps } from "@tanstack/highlight/react";

export const highlighter = createHighlighter({
  languages: [json],
});

export function CodeBlock({ copyText, htmlMarkup, title }: HighlightedCodeBlockProps) {
  const dispatch = useDispatch();

  const copyValue = useCallback(() => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        dispatch(showSnackbar("Content copied to clipboard."));
      })
      .catch(() => {
        dispatch(showSnackbar("Could not copy content to the clipboard."));
      });
  }, [dispatch, copyText]);

  return (
    <FormGroup
      title={title}
      actions={
        <Tooltip title="Copy response data" placement="top">
          <span>
            <Button
              type="button"
              color="inherit"
              aria-label="Copy response data"
              onClick={copyValue}
              sx={{ fontSize: "1rem", px: 1.25 }}
            >
              <Valkyrie icon={viCopy} />
            </Button>
          </span>
        </Tooltip>
      }
    >
      <figure className="grow text-sm">
        <div dangerouslySetInnerHTML={{ __html: htmlMarkup }} />
      </figure>
    </FormGroup>
  );
}
